import Button, { IButton } from 'components/Button';

const RejectButton = (props: IButton) => {
  return <Button className='bg-error100 text-red font-[MuseoSansCyrl700]' {...props} />;
};

export default RejectButton;
